import * as React from "react";
var applyTheme = function () {
    var root = document.documentElement;
    root.setAttribute("data-theme", "dark");
    document.body.classList.add("dark-mode");
};
export var ThemeContext = React.createContext({
    theme: "dark",
    setTheme: function () { },
    toggleTheme: function () { },
});
export var ThemeProvider = function (props) {
    React.useEffect(function () {
        applyTheme();
    }, []);
    var value = React.useMemo(function () { return ({
        theme: "dark",
        setTheme: function () { },
        toggleTheme: function () { },
    }); }, []);
    return (React.createElement(ThemeContext.Provider, { value: value }, props.children));
};
export var useTheme = function () { return React.useContext(ThemeContext); };
